exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.translation-source[data-v-fbee39ac] {\n    white-space: pre-wrap;\n}\n", ""]);

// exports
